import { Box, Button, Container } from '@mui/material';
import React, { useEffect, useState } from 'react';
// eslint-disable-next-line no-unused-vars
import { TimelineChart } from './TimelineChart';
import { page_data_selector } from './utils/page_data_selector';
import PrimaryFilterAndSort from './FilterAndSortPrimary';
import ColorBy from './ColorBy';
import ContainedButton from '../Buttons/ContainedButton';
import filter_chart from './utils/chart_filtering';
import FilterSecondary from './FilterSecondary';
// import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { MuiSwitch } from '../Switch/MuiSwitch';
import { calculateRemainingHeight } from '../../../util';
import { GridToolbar } from '@mui/x-data-grid-pro';
import { CustomDataGrid } from '../Table/CustomDataGrid';

const FullyIntegratedTimelineChart = ({
  paginated_x_view_data,
  x_key_name,
  formatted_json_data,
  columns,
  table_data,
  data_copy_for_filtering,
  update_data_copy_for_filtering,
  selected_primary_names,
  set_selected_primary_names,
  selected_color,
  color_by_options,
  update_color_by,
  primary_filter_name,
  secondary_filter_name,
  selected_secondary_filters,
  set_selected_secondary_filters,
  set_filtered_in,
  view_name,
  default_page = "1"
}) => {
  console.log({
    paginated_x_view_data,
    x_key_name,
    formatted_json_data,
    columns,
    data_copy_for_filtering,
    update_data_copy_for_filtering,
    selected_primary_names,
    set_selected_primary_names,
    selected_color,
    color_by_options,
    update_color_by,
    selected_secondary_filters,
    set_selected_secondary_filters,
    set_filtered_in,
    view_name
  });
  // console.log({ data_copy_for_filtering,paginated_x_view_data, x_key_name });
  const [paginated_data_copy, set_paginated_data_copy] = useState(data_copy_for_filtering);
  const [pages, set_pages] = useState(Object.keys(paginated_data_copy || {}));
  const [current_page, set_current_page] = useState("1");

  // console.log(selected_primary_names, set_selected_primary_names);

  // const [selected_primary_names, set_selected_primary_names] = useState([]);

  useEffect(() => {
    set_pages(Object.keys(paginated_data_copy || {}));
    set_current_page(default_page);
    set_current_page_data(page_data_selector(paginated_data_copy, "1"));
  }, [paginated_data_copy]);

  const [current_page_data, set_current_page_data] = useState([]);

  useEffect(() => {
    set_current_page_data(page_data_selector(paginated_data_copy, current_page, { machine_id: "Dummy" }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current_page]);

  const handle_page_change = (page_number) => {
    set_current_page(page_number);
  };

  const [show_table, set_show_table] = useState(false);

  // useEffect(() => {
  //   console.log({ current_page_data });
  // }, [current_page_data]);

  return (
    <Box className="">
      <Box className="px-2 flex gap-2 items-center justify-center">
        Chart View
        <MuiSwitch checked={show_table} onChange={(e) => {
          set_show_table(!show_table);
        }} />
        Table View
      </Box>
      <Box className={`min-h-[${calculateRemainingHeight(150)}] relative p-2`}>
        {
          show_table ? <>
            <Box className="w-full h-full">
              <CustomDataGrid
                // slots={{
                //   toolbar: GridToolbar
                // }}
                rows={table_data}
                columns={columns?.map(col => {
                  delete col.flex;
                  console.log({ col });
                  return {
                    ...col,
                    width: 200,
                    headerName: col.field.split("_").join(" ").toUpperCase()
                  };
                })}
                pagination
                initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
                pageSizeOptions={[10, 25, 50, 100]}
              />
              {/* <DataGridPro
                slots={{
                  toolbar: GridToolbar
                }}
                rows={table_data}
                columns={columns}
              /> */}
            </Box>
          </> :
            <>
              <Container className=''>
                <Box className="flex justify-start gap-2 flex-wrap">
                  <PrimaryFilterAndSort
                    primary_filter_name={x_key_name}
                    formatted_json_data={formatted_json_data}
                    complete_paginated_data={paginated_x_view_data}
                    update_chart_with_filtered_data={(data) => {
                      set_paginated_data_copy(data);
                      update_data_copy_for_filtering(data);
                    }}
                    selected_primary_names={selected_primary_names}
                    set_selected_primary_names={set_selected_primary_names}
                    update_filter_type={() => {
                      set_filtered_in((prev) => ({
                        ...prev,
                        [view_name]: {
                          primary: true,
                          secondary: false
                        }
                      }));
                    }}
                  />
                  <ColorBy
                    color_by_options={color_by_options}
                    selected_color={selected_color}
                    update_color_by={update_color_by}
                  />
                  {/* <ContainedButton onClick={() => {
            filter_chart(x_key_name, formatted_json_data, { machine_id: "PQABAL16", product_code: 8020046 }, selected_color);
          }}>
            Filter by Machine ID : PQABAL16
          </ContainedButton> */}
                  <FilterSecondary
                    selected_filters={selected_secondary_filters}
                    set_selected_filters={set_selected_secondary_filters}
                    filter_keys={["product_code", "analyst_id", "machine_id", "test_id"]}
                    primary_filter_name={primary_filter_name}
                    secondary_filter_name={secondary_filter_name}
                    formatted_json_data={formatted_json_data}
                    complete_paginated_data={paginated_x_view_data}
                    update_chart_with_filtered_data={(data) => {
                      set_paginated_data_copy(data);
                      update_data_copy_for_filtering(data);
                    }}
                    selected_primary_names={selected_primary_names}
                    set_selected_primary_names={set_selected_primary_names}
                    color_by={selected_color}
                    x_key_name={x_key_name}
                    update_filter_type={() => {
                      set_filtered_in((prev) => ({
                        ...prev,
                        [view_name]: {
                          primary: false,
                          secondary: true
                        }
                      }));
                    }}
                  />
                  {/* <ColorBy x_key_name={x_key_name} color_by_options={{
            spec_id: {
              enabled: true,
              selected: true
            },
          }} /> */}
                </Box>
                {
                  current_page_data &&
                  <TimelineChart current_page_data={current_page_data} chart_key={x_key_name} />
                }
                <Box className="m-2 flex gap-2 flex-wrap">
                  {
                    pages.map((page, idx) => <Button
                      variant={current_page === page ? "outlined" : "contained"}
                      sx={{
                        color: current_page === page ? "" : "white"
                      }}
                      onClick={() => {
                        handle_page_change(page);
                      }} key={`${idx}_machine_view_pagination_button_${page}`}>{page}</Button>)
                  }
                </Box>
              </Container>
            </>
        }
      </Box>
    </Box>
  );
};

export default FullyIntegratedTimelineChart;